/**
 * @param {object} params
 * @param {import("../../types/Customer").Customer} [params.customer]
 *
 * @returns {boolean}
 */
export function isCustomerFromGolbey({ customer }) {
  if (
    customer?.default_address &&
    customer.default_address.zipcode === "88190" &&
    customer.default_address.city.toLocaleLowerCase() === "golbey"
  ) {
    return true;
  }
  return false;
}
